enum TimeConfig {
    FIVE_MINUTES = (1000 * 60 * 5),
}

export default TimeConfig